export default {
  columns: [{ prop: 'trans_contract', label: 'contracts', editable: true }],
  style: { dynamicSizing: false },
};